<template>
  <div class="card">
    <div class="card-header pb-0 ">
      <h6>Influencers : {{this.influencers.length}} คน</h6>
    </div>
    <div class="card-body px-0 mx-0 pt-0 pb-2" style="width:100%">
      <div class="table-responsive p-0 ">
        <table class="table table-sm align-items-center mb-0 mx-0">
          <thead>
            <tr >
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ">Line Display / UID</th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >Members</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ยอดเติม</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >ส่วนแบ่ง</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Status</th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="influ in influencers" :key="influ.username">
              <td>
                <div class="d-flex px-2 py-1">
                  <!-- <div>
                    <img
                      src="../../assets/img/team-2.jpg"
                      class="avatar avatar-sm me-3"
                      alt="user1"
                    />
                  </div> -->
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{influ.line_display.slice(0,15)}}</h6>
                    <!-- <p class="text-xs text-secondary mb-0">{{influ.username.slice(0,15) + ".."}}</p> -->
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0">
                  <button type="button" class="btn btn-info btn-icon" style="width:50px; text-align:center" 
                  @click="influ_button_clicked(influ)">
                    {{influ.referree.length}} 
                    <!-- <i class="ni ni-bold-down text-dark" style="position:relative;right:0px"></i> -->
                  </button>
                </p>
              </td>
              <td class="align-middle text-center text-sm">
                <span class="text-secondary text-xs font-weight-bold">{{influ.total_amount}}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{influ.total_point}}</span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">-</span>
              </td>

            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
const qs = require('querystring')
var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "influencers-table",
  data() {
    return {
      influencers : [],
      users : [],
      // username : "admin_jay",
    }
  },
  methods :{ 
    influ_button_clicked (influ) {
      console.log(influ.referree[0].line_display)
      this.$store.state.members = influ.referree
      if (influ.line_display != 'chakrit') {
        this.$router.push({
          name: 'Referral',
          params : {
            line_display : influ.line_display,
            total_members : influ.referree.length,
            total_points : influ.point,
            members : influ.referree
            

          }
        })
      } else {
        // this.$store.state.memo = response.data.t1;
        // this.$store.state.user = response.data.user;
        host_api=window.localStorage.getItem('$host_api');
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        const requestBody = {
            username: 'chakrit',
            password: '999999999'
        }

        axios.post(host_api+"/admin/login_admin", qs.stringify(requestBody), config,
          ).then(response => {
               if (response.data.result == "chakrit") {
                this.$store.state.memo = response.data.t1;
                this.$store.state.user = response.data.user;
                this.$router.push({name: 'ReferralExtra'})
              }
              else {
                  console.log("False")
              }
          })
        // this.$router.push({
        //   name: 'ReferralExtra',
        //   params : {
        
        //   }
        // })
      }
    },
    reload_influencers(){           
      host_api=window.localStorage.getItem('$host_api');
      // console.log("H-api : " + host_api)
      const config = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      const requestBody = {
      }

    //   axios.post(host_api+"/admin/users/all", qs.stringify(requestBody), config,
      axios.post(process.env.VUE_APP_Influencers_List, qs.stringify(requestBody), config,
        ).then(response => {
            if (response.data.status == "success") {

              // Push Influencers List
            //   response.data.users.forEach(user => {
              response.data.influencers.forEach(user => {
                this.users.push(user)
                if (user.type == 1)
                  this.influencers.push(user)
              });

              // Sum Influ ref
              this.influencers.forEach(influ => {
                var referree = []
                var amount = 0;
                var point = 0;
                var all_users = this.$store.state.memo
                all_users.forEach(member => {
                  if (member.ref_username == influ.username) {
                    referree.push(member)
                    if (member.total_amount != null || member.total_amount != undefined){
                      amount = amount + parseInt( member.total_amount);
                      point = point + parseInt( member.total_point);
                    }
                  }
                });
                // console.log(influ.line_display + ' : ' + amount)
                influ.total_amount = amount
                influ.total_point = point
                influ.referree = referree
              });

              // this.influencers[0].referree.forEach(ref => {
              //   console.log(ref.username)
              // });



              this.influencers.sort(function(a, b) { 
                return b.referree.length - a.referree.length  
              });
            
            }
            else {
                console.log("False")
            }
        })
    }, 
  },
  mounted() {
    this.reload_influencers();
  }
};
</script>
